import React, {FC, ReactElement, useCallback, useEffect, useState} from "react";
import LoaderWithCompanySelected from "../../../components/LoaderWithCompanySelected";
import {Button, Grid, TextField} from "@mui/material";
import {DropzoneArea} from "react-mui-dropzone";
import ButtonWithConfirmation from "../../../components/button/ButtonWithConfirmation";
import {RecogniseSinglePurchaseInvoice} from "./RecogniseSinglePurchaseInvoice";
import {purchaseInvoiceRecognitionApi} from "../../../backend/PurchaseInvoiceRecognitionApi";
import {getFileBase64} from "../../../utils/ReadFile";
import {observer} from "mobx-react";
import {companyApi} from "../../../backend/CompanyApi";
import {selectedCompanyStore} from "../../../store/SelectedCompany";

interface IProps {
}

interface FileAndTaskId {
    file: File,
    taskId: string,
}

export const RecognisePurchaseInvoices: FC<IProps> = observer((): ReactElement => {
    const [files, setFiles] = useState<File[]>([])
    const [submittedForRecognition, setSubmittedForRecognition] = useState<FileAndTaskId[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [extraPrompt, setExtraPrompt] = useState<string>("")

    const fetchExtraPrompt = useCallback(async () => {
        if (selectedCompanyStore.isSelected) {
            const settings = await companyApi.fetchSettings(selectedCompanyStore.selectedCompanyId);
            setExtraPrompt(settings.aiData.purchaseInvoiceRecognitionPrompt)
        }
        setLoading(false)
    }, []);

    useEffect(() => {
        fetchExtraPrompt().then(_ => {
        })
    }, [])

    const recognise = useCallback(async () => {
        const startedTasks = await Promise.all(files.map(async file => {
            const taskId = await purchaseInvoiceRecognitionApi.start(file.name, await getFileBase64(file), extraPrompt);
            return {file, taskId};
        }))
        setSubmittedForRecognition(startedTasks)
    }, [files, setSubmittedForRecognition, extraPrompt]);

    const clear = useCallback(async () => {
        setLoading(false)
        setFiles([])
        setSubmittedForRecognition([])
        await fetchExtraPrompt()
    }, [setFiles, setSubmittedForRecognition]);


    return <LoaderWithCompanySelected loading={loading}>
        <Grid container spacing={2}>
            {(submittedForRecognition.length == 0) && <>
                <Grid item xs={12}>
                    <DropzoneArea
                            maxFileSize={4500000} //4.5MB
                            dropzoneText={"Drag and drop a file here or click"}
                            filesLimit={100}
                            showPreviews={false}
                            showPreviewsInDropzone={true}
                            showAlerts={['error']}
                            useChipsForPreview={true}
                            showFileNamesInPreview={true}
                            initialFiles={files}
                            onChange={(files) => {
                                setFiles(files)
                            }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                            label="Extra recognition prompt"
                            value={extraPrompt}
                            multiline
                            fullWidth
                            rows={6}
                            maxRows={12}
                            onChange={e => setExtraPrompt(e.target.value)}
                    />
                </Grid>
            </>}

            {(submittedForRecognition.length != 0) &&
                    <Grid item container xs={12} columnSpacing={2}>
                        {submittedForRecognition.map(({file, taskId}) =>
                                <Grid key={taskId} item xs={12}>
                                    <RecogniseSinglePurchaseInvoice file={file} taskId={taskId}/>
                                </Grid>)}
                    </Grid>
            }

            <Grid item container xs={12} columnSpacing={2}>
                <Grid item>
                    <ButtonWithConfirmation
                            onClick={recognise}
                            disabled={submittedForRecognition.length != 0} color="primary" variant="contained">
                        Recognise
                    </ButtonWithConfirmation>
                </Grid>
                <Grid item>
                    <Button color="secondary" variant="contained" onClick={clear}>
                        Clear
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    </LoaderWithCompanySelected>
})